module.exports = __webpack_public_path__ + "static/img/hb_20-min.6daab10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_20-min.png
// module id = O7HF
// module chunks = 1